import {api} from "./api";

export class Whitelist {
    prefix() {
        return "whitelist"
    }

    checkWallet(walletAddr) {
        return api.post(`${this.prefix()}/check/wallet`, {wallet_addr: walletAddr}) //TODO Backend API
    }

    checkCode(code) {
        return api.post(`${this.prefix()}/check/code`, {code: code}) //TODO Backend API
    }

    create(obj) {
        return api.post(`${this.prefix()}/claim`, obj)
    }
}

export default new Whitelist()